@let obs =
  {
    searchWishlist: searchWishlist(),
  };

@if (obs.searchWishlist.results) {
  @for (product of obs.searchWishlist.results; track trackByEntry) {
    <sd-product-item class="grid-item grid-view-mode" [product]="product"></sd-product-item>
  }
}

@if (obs.searchWishlist.pagination) {
  <div class="pagination">
    <sd-pagination
      [pagination]="obs.searchWishlist.pagination"
      pageRoute="."
      queryParam="page"
      [defaultPage]="0"
    ></sd-pagination>
  </div>
}
